import React from 'react';

import {
  Footer,
  FooterLink,
  ShareIconsWrapper,
  WantMoreWrapper,
} from '@/themes/globalStyles';

import { ShareIcons } from '../ShareIcons';

interface LandingPageFooterProps {
  backgroundColor: string;
  organization: {
    name: string;
    privacyPolicyUrl?: string;
    websiteUrl?: string;
  };
  shareMessage: string;
  shareTitle?: string;
  socialShareButtonEnabled: boolean;
  textColor?: string;
  uuid: string | Array<string> | undefined;
}

export const LandingPageFooter = ({
  backgroundColor,
  organization,
  shareMessage,
  shareTitle,
  socialShareButtonEnabled,
  textColor,
  uuid,
}: LandingPageFooterProps) => {
  const websiteLink = organization.websiteUrl?.startsWith('http://') || organization.websiteUrl?.startsWith('https://') ? organization.websiteUrl : `https://${organization.websiteUrl}`;

  return (
    <Footer
      backgroundcolor={backgroundColor}
      textcolor={textColor || '#000'}
    >
      {socialShareButtonEnabled && (
        <>
          <WantMoreWrapper>{shareMessage}</WantMoreWrapper>
          <ShareIconsWrapper>
            <ShareIcons
              textcolor={textColor}
              title={shareTitle}
              customIcons
              uuid={uuid}
            />
          </ShareIconsWrapper>
        </>
      )}
      <div>
        <FooterLink
          href={organization.websiteUrl ? websiteLink : undefined}
          target="_blank"
          rel="noopener noreferrer"
        >
          {organization.name}
        </FooterLink>
        &nbsp;
        |
        &nbsp;
        <FooterLink
          href="https://www.muster.com/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Muster Privacy Policy
        </FooterLink>
        &nbsp;
        |
        &nbsp;
        <FooterLink
          href="https://www.muster.com/terms-of-service"
          target="_blank"
          rel="noopener noreferrer"
        >
          Muster Terms of Service
        </FooterLink>
        {organization.privacyPolicyUrl && (
          <>
            &nbsp;
            |
            &nbsp;
            <FooterLink
              href={organization.privacyPolicyUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              {organization.name}
              &apos;s Privacy Policy
            </FooterLink>
          </>
        )}
      </div>
    </Footer>
  );
};
